import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphanumericInput]'
})
export class AlphanumericInputDirective {
  private readonly invalidCharacters = /[^\p{L}\p{N}_-]/gu;

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener('input')
  onInput(): void {
    const input = this.elementRef.nativeElement;
    const initialValue = input.value;
    const sanitizedValue = this.sanitize(initialValue);

    if (initialValue === sanitizedValue) {
      return;
    }

    const selectionStart = input.selectionStart === null ? initialValue.length : input.selectionStart;
    const newCursorPosition = initialValue.slice(0, selectionStart).replace(this.invalidCharacters, '').length;
    input.value = sanitizedValue;
    this.updateCursorPosition(input, newCursorPosition);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  private sanitize(value: string): string {
    return value.replace(this.invalidCharacters, '');
  }

  private updateCursorPosition(input: HTMLInputElement, position: number): void {
    try {
      input.setSelectionRange(position, position);
    } catch {
      return;
    }
  }
}
